/**
 * framer-motion mirror of the CSS motion tokens defined in
 * src/styles/index.css (`--duration-*` / `--ease-*`). framer-motion takes
 * numeric seconds + cubic-bezier arrays, not CSS custom properties, so the
 * values are duplicated here. Keep the two in sync (same pattern as the
 * portal-token mirror in index.css).
 */
export const DUR = {
  fast: 0.12, // --duration-fast
  base: 0.2, // --duration-base
  slow: 0.32, // --duration-slow
} as const;

// 4-tuples (framer-motion's cubic-bezier BezierDefinition) — typed mutable so
// they're assignable to Transition.ease without a cast.
export const EASE = {
  standard: [0.2, 0, 0, 1] as [number, number, number, number],
  emphasized: [0.22, 1, 0.36, 1] as [number, number, number, number],
  exit: [0.4, 0, 1, 1] as [number, number, number, number],
};
